import { render } from "./MultiAffairReceptionModal.vue?vue&type=template&id=ed22351c&scoped=true"
import script from "./MultiAffairReceptionModal.vue?vue&type=script&lang=js"
export * from "./MultiAffairReceptionModal.vue?vue&type=script&lang=js"

import "./MultiAffairReceptionModal.vue?vue&type=style&index=0&id=ed22351c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed22351c"]])

export default __exports__